import Nav from '../../components/Navbar/Navbar.js'
import './Header.css'

const Header = () => {
	return (
		<header className='Header'>
			<div className='container'>
				<Nav />
			</div>
		</header>
	)
}

export default Header
